export enum ChangeSetTypeEnum {
    Unknown = 0,
    Creation = 1,
    Deletion = 2,
    Update = 3,
}

export const getChangeSetTypeName = (type: ChangeSetTypeEnum): string => {
    switch (type) {
        case ChangeSetTypeEnum.Creation:
            return 'Created';
        case ChangeSetTypeEnum.Deletion:
            return 'Deleted';
        case ChangeSetTypeEnum.Update:
            return 'Updated';
        case ChangeSetTypeEnum.Unknown:
        default:
            return 'Unknown';
    }
};
